import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import RewardBenefitsContent from '../../components/RewardBenefitsContent';

const RewardBenefits = () => {
    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <Header />
                <main className="page_content">
                    <PageTitle pageTitle={'Copper-Silver-Bronze-Gold-rewards'} pagesub={'Home'} />
                    <div className="container" style={{ paddingTop: "60px", paddingBottom: "60px" }}>
                        <RewardBenefitsContent />
                    </div>
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    );
};

export default RewardBenefits;
